export class LoginVM {
    public username: string;
    public password: string;
    public client_id: string;
    public client_secret: string;
    public grant_type: string;
}
